import React from 'react';
import { Box, Image, Flex, Heading, Text } from 'rebass/styled-components';
import { StaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Section from '../components/Section';
import Triangle from '../components/Triangle';
import ProgressBar from '../components/ProgressBar';

const Background = () => (
  <div>
    <Triangle color="backgroundDark" height={['15vh', '10vh']} width={['100vw', '100vw']} invertX />
    <Triangle color="secondary" height={['50vh', '40vh']} width={['70vw', '40vw']} invertY />
    <Triangle color="primaryDark" height={['40vh', '15vh']} width={['100vw', '100vw']} invertX invertY />
  </div>
);

const Skills = () => (
  <Section.Container id="skills" Background={Background}>
    <Section.Header name="skills" icon="👨‍🔧" label="skills" />
    <StaticQuery
      query={graphql`
        query skillsQuery {
          contentfulAbout {
            skillTypes {
              name
              skills {
                name
                rating
                logo {
                  title
                  image: resize(width: 200, quality: 100) {
                    src
                  }
                }
              }
            }
          }
        }
      `}
      render={data => {
        const { skillTypes } = data.contentfulAbout;
        return (
          <Flex>
            {skillTypes.map((skillType, i) => {
              return (
                <Box width={1 / 4} p={3}>
                  <Fade bottom delay={i * 200} key={skillType.id}>
                    <Heading mb={2}>{skillType.name}</Heading>
                    {skillType.skills.map(skill => {
                      return (
                        <Flex p={2} alignItems="center">
                          <Box width={1 / 6} height={40}>
                            <Image src={skill.logo.image.src} alt={skill.logo.title} />
                          </Box>
                          <Box width={2 / 6} ml={3}>
                            <Text>{skill.name}</Text>
                          </Box>
                          <Box width={3 / 6}>
                            <ProgressBar percent={skill.rating} />
                          </Box>
                        </Flex>
                      );
                    })}
                  </Fade>
                </Box>
              );
            })}
          </Flex>
        );
      }}
    />
  </Section.Container>
);

export default Skills;
